import { URLS } from "@payping/utilities-shared/consts";
import { UserManager, UserManagerSettings } from "oidc-client-ts";

export const userManagerConfig: UserManagerSettings = {
  authority: URLS.AUTH_URL,
  client_id: "payping-BNPLClient",
  redirect_uri: `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ""
  }/oauth_callback`,
  response_type: "code",
  scope: ["openid", "profile", "bnpl:consumerread", "bnpl:consumerwrite", "nationalcode", "birthday"].join(" "),
  post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ""
  }/`,
};

export const userManager = new UserManager(userManagerConfig);
